import { useSelector } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJTextToImageRight from '../view/FJTextToImageRight';

const FJTextToImageRightContainer = () => {
    useLocalStore();

    const isShowPresetImageBox = useSelector(state => state.textToImage.isShowPresetImageBox);

    return <FJTextToImageRight isShowPresetImageBox={isShowPresetImageBox} />;
};

export default FJTextToImageRightContainer;
